import { useAuthContext } from 'components/Login/hooks';
import useProfile from 'customer/components/iam/Profile/hooks';
import useKycProfile from 'customer/components/kyc/Profile/hooks';
import { useAppContext } from 'customer/context';
import { useEffect, useState } from 'react';
import { ProfileV2 } from 'types/kyc/Profile';
import { useHelpscoutMigration, useHelpscoutSignature } from './hooks';

export function useHelpscoutSetup() {
  const { helpscoutBeaconId, isFeatureHelpscoutBeacon } = useAppContext();
  const { data: authContext } = useAuthContext();
  const { profile, read } = useKycProfile();
  const { profileId } = useProfile();
  const [name, setName] = useState<string | undefined>();

  useEffect(() => {
    if (!profile && profileId) {
      read(profileId);
    }

    let displayName = profile?.name;
    if (profile) {
      if ('user' in profile) {
        displayName = `${profile.user?.firstName} ${profile?.user?.lastName}`;
      }
      if ((profile as ProfileV2)?.updatedBy) {
        const profileV2 = profile as ProfileV2;
        const user = profileV2?.users?.find(({ authUserId }) => {
          return authUserId === authContext?.userId;
        });
        if (user) {
          displayName = `${user.person.firstName} ${user.person.lastName}`;
        }
      }
    }

    setName(displayName);
  }, [profile, profileId]);

  const { data: helpscoutSignature, isSuccess: isHelpscoutSignatureSuccess } =
    useHelpscoutSignature(!!authContext?.userId && !!isFeatureHelpscoutBeacon);
  const {
    data: helpscoutMigration = {},
    isSuccess: isHelpscoutMigrationSuccess,
  } = useHelpscoutMigration(
    !!authContext?.userId && !!isFeatureHelpscoutBeacon,
  );

  useEffect(() => {
    if (!isFeatureHelpscoutBeacon) return;
    if (typeof window.Beacon === 'undefined') return;
    window.Beacon('init', helpscoutBeaconId);
  }, []);

  useEffect(() => {
    if (!isFeatureHelpscoutBeacon) return;
    if (typeof window.Beacon === 'undefined') return;
    if (!authContext?.auth) return;
    if (!isHelpscoutSignatureSuccess) return;
    if (!profileId) return;

    const beacon = {
      signature: helpscoutSignature.signature,
      email: authContext.email,
      name,
      'support-url': `${window.location.origin}/hs/${profileId}`,
    };

    if (helpscoutMigration.migrated) {
      window.Beacon('identify', beacon);
      window.Beacon('navigate', '/ask/');
    }
  }, [
    profile,
    name,
    profileId,
    authContext?.auth,
    isHelpscoutSignatureSuccess,
    isHelpscoutMigrationSuccess,
    helpscoutMigration.migrated,
  ]);
}
